import CanvasObjLibrary from './CanvasObjLibrary.js';

if(!window.CanvasObjLibrary)window.CanvasObjLibrary = CanvasObjLibrary;